import { withInstall } from '@touchvue/utils'
import CenterScroll from './src/CenterScroll.vue'

export const ToCenterScroll = withInstall(CenterScroll)
export default ToCenterScroll

export * from './src/center-scroll'
